import { create } from 'zustand'
import { omit } from 'lodash-es'
import type { GqlOperationName } from 'gql/names/types'

interface OperationStatusState {
  loadingOperations: GqlOperationName[]
  operationErrors: Partial<Record<GqlOperationName, string | null>>
  startLoading: (operationName: GqlOperationName) => void
  stopLoading: (operationName: GqlOperationName) => void
  setError: (operationName: GqlOperationName, error: string | null) => void
}

export const useOperationStatusStore = create<OperationStatusState>((set) => ({
  loadingOperations: [],
  operationErrors: {},

  startLoading: (operationName) => {
    set((state) => ({
      loadingOperations: [...state.loadingOperations, operationName],
      operationErrors: state.operationErrors[operationName]
        ? omit(state.operationErrors, operationName)
        : state.operationErrors,
    }))
  },

  stopLoading: (operationName) => {
    set((state) => ({
      loadingOperations: state.loadingOperations.filter((name) => name !== operationName),
    }))
  },

  setError: (operationName, error) => {
    set((state) => ({
      operationErrors: {
        ...state.operationErrors,
        [operationName]: error,
      },
    }))
  },
}))
